const getENV = (key: string): string => {
    return process.env[`REACT_APP_${key}`] ?? '';
};

const config = {
    NODE_ENV: getENV('NODE_ENV'),
    API_URL: getENV('API_URL'),
    SSO_URL: getENV('SSO_URL'),
    CHAT_FRONT_URL: getENV('CHAT_FRONT_URL'),
    WIZ_COMMON_URL: getENV('WIZ_COMMON_URL'),
    SERVICE_ID: getENV('SERVICE_ID') || 'DOKOCREW',   // 개발·상용 DB 모두 DOKOCREW 로 변경됨(2026-10 id-migrate). 앱(dokocrew_native)도 전 환경 DOKOCREW
    CLIENT_ID: 'DOKOCREW_CLIENT',
    ENCRYPTION_KEY: getENV('ENCRYPTION_KEY'),
    KAKAO_MAP_KEY: getENV('KAKAO_MAP_KEY'),
    KAKAO_REST_KEY: getENV('KAKAO_REST_KEY'),
    GOOGLE_MAPS_API_KEY: getENV('GOOGLE_MAPS_API_KEY'),
    GEOAPIFY_KEY: getENV('GEOAPIFY_KEY'),
    ADSENSE_CLIENT: getENV('ADSENSE_CLIENT'),       // Google AdSense ca-pub-xxx
    ADSENSE_SLOT: getENV('ADSENSE_SLOT'),            // AdSense 슬롯 ID
    ADFIT_UNIT_ID: getENV('ADFIT_UNIT_ID'),          // 카카오 Adfit 광고 단위 ID

    // ===== Feature flags — 한 곳만 변경하면 관련 화면 모두 토글 =====
    /**
     * 실시간 위치 화면의 참여자 이동 경로 polyline 표시.
     * false 면 snapshot fetch / STOMP 점 누적 / polyline 렌더 모두 skip.
     */
    PATH_LINES_ENABLED: true,
};

if (config.NODE_ENV !== 'prod') {
    console.log('Config Loading...', config);
}

export default config;
